import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { captureError, Severity } from '@chegg/observability';
import { client, Commands } from '@chegg/pricing-sdk';
import { CW_TEAM_NAME } from '../constants/Strings';
import { PRODUCT_TYPE_TO_OFFER_ID } from '../common/interfaces';
export var US_COUNTRY_CODE = 'US';
export var BASE_EXPERIMENT = 'BASE';
export var USE_PRICING_ERROR_LOCATION = 'usePricingAsync';
export var DEFAULT_PRICING_TIMEOUT = 5000;

// Add other params for different pricingApi functions as needed (i.e. UsePricingByExternalIdParams)

/**
 * Get dataRequested based on country code. For AU & CA, we need to show price with tax. Hence returns
 * Commands.ELIGIBILITY_V2_WITH_TAX and Commands.ELIGIBILITY_V2 as default.
 * @param countryCode: country code
 * @returns Commands
 */
export var getDataRequested = function getDataRequested(countryCode) {
  switch (countryCode) {
    case 'AU':
    case 'CA':
      return Commands.ELIGIBILITY_V2_WITH_TAX;
    default:
      return Commands.ELIGIBILITY_V2_WITH_VPN;
  }
};

/**
 * Hook to get pricing of a given subscription based of data requested params & product code
 * Learn more: http://gce-document.test.cheggnet.com:1200/#pricing-api-pricing
 */
export var usePricingAsync = function usePricingAsync(_ref) {
  var dataRequested = _ref.dataRequested,
    productCode = _ref.productCode,
    _ref$countryCode = _ref.countryCode,
    countryCode = _ref$countryCode === void 0 ? US_COUNTRY_CODE : _ref$countryCode,
    _ref$openToUpgrade = _ref.openToUpgrade,
    openToUpgrade = _ref$openToUpgrade === void 0 ? false : _ref$openToUpgrade,
    _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip,
    pricePlanInput = _ref.pricePlanInput;
  var _useState = useState(!skip),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(function () {
    if (skip) {
      return;
    }
    if (!data && productCode) {
      setLoading(true);
      /**
       * Assumes pricing sdk authorize has already been called
       */
      client.pricingApi.getPricingV2({
        countryCode: countryCode,
        dataRequested: dataRequested !== null && dataRequested !== void 0 ? dataRequested : getDataRequested(countryCode),
        experiment: BASE_EXPERIMENT,
        // @ts-ignore
        offerId: PRODUCT_TYPE_TO_OFFER_ID[productCode],
        productCode: productCode,
        openToUpgrade: openToUpgrade,
        pricePlanInput: pricePlanInput
      }, {
        timeout: DEFAULT_PRICING_TIMEOUT
      }).then(function (response) {
        setData(response.data);
        if (response.errors) {
          setError(response.errors);
        }
      })["catch"](function (reason) {
        captureError({
          error: reason,
          location: USE_PRICING_ERROR_LOCATION,
          severity: Severity.ERROR
        }, {
          teamName: CW_TEAM_NAME
        });
        setError(reason);
      })["finally"](function () {
        return setLoading(false);
      });
    }
  }, [skip, productCode]);
  if (skip) {
    return {
      status: 'skipped'
    };
  }
  if (loading) {
    return {
      status: 'loading'
    };
  }
  if (!data && error) {
    return {
      status: 'error',
      metadata: error
    };
  }
  return {
    status: 'ok',
    data: data
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/usePricingAsync.js
// module id = 639
// module chunks = 11